import { buildClient } from '../utils/url';
var cmsService = {
    baseUrl: {
        SERVICE: 'cms',
        ACTIVITY_DATA_SOURCES: 'activity-data-sources',
        EMISSION_FACTOR_IMPORTS: 'emission-factor-imports',
    },
    activity_data_sources: {
        GET_MANY: '/',
        CREATE: '/',
        UPDATE: '/',
    },
    emission_factor_imports: {
        CREATE: '/',
        UPDATE: '/',
        DELETE: '/',
        GET_FACTOR_VALUE: '/factor-value',
    },
};
var cmsServiceClient = {
    activity_data_sources: buildClient(cmsService.baseUrl.ACTIVITY_DATA_SOURCES, cmsService.activity_data_sources),
    emission_factor_imports: buildClient(cmsService.baseUrl.EMISSION_FACTOR_IMPORTS, cmsService.activity_data_sources),
};
export { cmsService, cmsServiceClient };
//# sourceMappingURL=cms-service.js.map